import { Layer, Source } from "react-map-gl/mapbox"
import type { IParcel } from "@/types/explore"

interface SelectedLayerProps {
  selectedParcels?: IParcel[]
}

export const SelectedLayer = ({ selectedParcels }: SelectedLayerProps) => {
  if (!selectedParcels || selectedParcels.length === 0) {
    return null
  }

  return (
    <Source
      id="selected-parcel-source"
      type="geojson"
      data={{
        type: "FeatureCollection",
        features: selectedParcels.map((parcel) => ({
          type: "Feature",
          geometry: parcel.geometry,
          properties: parcel.properties,
        })),
      }}
    >
      <Layer
        id="selected-parcel-layer"
        type="fill"
        source="selected-parcel-source"
        paint={{ "fill-color": "#FF0000", "fill-opacity": 0.5 }}
      />
      <Layer
        id="selected-parcel-border"
        type="line"
        source="selected-parcel-source"
        paint={{ "line-color": "#FF0000", "line-width": 2, "line-opacity": 0.8 }}
      />
    </Source>
  )
}
